/**
 * Shared helpers for the Accounting dashboard split.
 */

export const SOURCE_LABELS = {
  payroll: { label: "Payroll", color: "bg-blue-100 text-blue-700" },
  rental_payment: { label: "Rentals", color: "bg-emerald-100 text-emerald-700" },
  landlord_payout: { label: "Landlord Payout", color: "bg-teal-100 text-teal-700" },
  petty_cash: { label: "Petty Cash", color: "bg-amber-100 text-amber-700" },
  finance: { label: "Finance", color: "bg-purple-100 text-purple-700" },
  broker_deposit: { label: "Broker Deposit", color: "bg-indigo-100 text-indigo-700" },
  broker_payout: { label: "Broker Payout", color: "bg-indigo-100 text-indigo-700" },
  manual: { label: "Manual", color: "bg-gray-100 text-gray-700" },
};

export const ACCOUNT_SUBTYPES = {
  asset: ["current_asset", "fixed_asset", "bank", "cash", "receivable"],
  liability: ["current_liability", "long_term_liability", "payable"],
  equity: ["owner_equity", "retained_earnings", "capital"],
  revenue: ["operating_revenue", "other_income", "rental_income", "commission_income"],
  expense: ["operating_expense", "payroll_expense", "administrative", "utilities", "maintenance"],
};

export const formatCurrency = (amount) =>
  `K ${(amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;

export const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const SourceBadge = ({ entry }) => {
  const key =
    entry?.reference_type ||
    (entry?.created_by && entry?.created_by !== "system" ? "manual" : null);
  const meta = key ? SOURCE_LABELS[key] : null;
  if (!meta) {
    return (
      <span className="inline-block text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600">
        Manual
      </span>
    );
  }
  return (
    <span
      className={`inline-block text-xs px-2 py-0.5 rounded font-medium ${meta.color}`}
      title={entry.reference_id ? `Ref: ${entry.reference_id}` : "Auto-posted"}
      data-testid={`source-badge-${key}`}
    >
      {meta.label}
    </span>
  );
};
